export const manageUcrtSchema = {
   
    location: {
        type: "string",
        required: true,
        properties: {
            empty: "Please select geography",
        }
    },
    workforceCapacity: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter workforce capacity"
        }
    },
    staffingStatus: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter staffing status",
            positive: "Number of staffing status must be at least 1",
            number: "Please enter number only",
            maxLength:{
                limit:3,
                msg: "Number of staffing status is not allow more than 100" 
            },     
        }  
    },
    numberOfStaffOnCovidRelatedAbsence: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter no. of staff on covid related absence",
            positive: "Number of staff on covid related absence must be at least 0",
            number: "Please enter number only",
            maxLength:{
                limit:3,
                msg: "Number of staff on covid related absence of beds is not allow more than 100" 
            }, 
        }
    },

    bcpService: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter bcp service"
        }
    },
    caseloadPatients: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter caseload"
        }
    },

    virtuWardPatients: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter virtu ward patients"
        }
    },

    duePatients: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter patietn due for discharge"
        }   
    },

    carePackages: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter number of care package"
        }   
    },
    // anyChanges: {
    //     type: "string",
    //     required: true,
    //     properties: {
    //         empty: "Please enter number of care package"
    //     }   
    // },
   
}